<template>
  <div id="SleepQualityPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="ثبت ساعت خواب"></ActionBar>
    <div v-if="isLoaded" class="row container mx-auto no-gutters p-0 mt-2">
      <div v-if="!hasRegistered" class="row mx-2 mt-10 knowledge-base-body">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="primary"
              dark>
            این اطلاعات ماهی یکبار باید ثبت شود و شما در ماه جاری ثبت کرده اید.
          </v-alert>
        </div>
      </div>
      <div v-else class="col-12 rounded-b-lg header-rounded bg-white card-shadow">
        <div class="third-background header-rounded mb-3 white--text p-2"><span> </span></div>
        <div
            class="mt-1 font-weight-bold mr-5">برای ثبت ساعت خواب ابتدا تاریخ مورد نظر خود را انتخاب کنید:
        </div>
        <div v-if="showDate" class="col-12 col-md-5">

          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="auto"
              offset-y
              transition="scale-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="inputDate2"
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar"
                  class="input-border gray-bg-input"
                  dense
                  hide-details
                  readonly
                  solo></v-text-field>
            </template>
            <v-date-picker
                v-model="date2"
                locale="fa-ir"
                width="256"
                @input="inputDatePicker2"></v-date-picker>
          </v-menu>
        </div>
        <div v-if="canRegister" class="row p-2">


          <div class="col-6 col-md-5">
             <span
                 class="mt-1 font-weight-bold">از ساعت:</span>
            <v-dialog
                v-model="startTimeDialog"
                width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="startTimeDialogInput"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-clock-time-four-outline"
                    class="mr-1 input-border gray-bg-input "
                    dense
                    hide-details
                    label="از ساعت"
                    readonly
                    solo></v-text-field>
              </template>
              <v-time-picker
                  v-if="startTimeDialog"
                  v-model="startTimeDialogInput"
                  format="24hr"
                  full-width>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="startTimeDialog = false">
                  تایید
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </div>
          <div class="col-md-5 col-6">
             <span
                 class="mt-1 font-weight-bold">تا ساعت:</span>
            <v-dialog
                v-model="endTimeDialog"
                width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="endTimeDialogInput"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-clock-time-four-outline"
                    class="mr-1 input-border gray-bg-input "
                    color="forth"
                    dense
                    hide-details
                    label="تا ساعت"
                    readonly
                    solo
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="endTimeDialog"
                  v-model="endTimeDialogInput"
                  color="forth"
                  format="24hr"
                  full-width>
                <v-spacer></v-spacer>
                <v-btn
                    color="forth"
                    text
                    @click="endTimeDialog = false">
                  تایید
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </div>

          <div class="light-gray-bottom-border col-12 col-md-5 ">
            <span
                class="mt-1 font-weight-bold">توضیحات:</span>
            <v-textarea
                v-model="description"
                auto-grow
                class="input-border gray-bg-input "
                dense
                hide-details
                placeholder="توضیحات"
                solo
                type="text">
            </v-textarea>
          </div>
          <div class="col-12 text-left mb-3">
            <v-btn :disabled=" endTimeDialogInput === null || startTimeDialogInput === null" class="px-10" color="forth"
                   rounded
                   @click="showConfirmDialog = true">
              <span class="white--text">ثبت</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showConfirmDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">لطفا از صحیح بودن موارد وارد شده اطمینان حاصل نمایید!</div>
          <div class="mb-0 black--text font12px">در صورت ثبت امکان تغییر آن وجود ندارد.</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showConfirmDialog = !showConfirmDialog">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="registerTime">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import moment from "moment-jalaali";

export default {
  name: "SleepQuality",
  metaInfo: {
    title: 'مسیربرتر-ثبت ساعت خواب'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    showDate: true,
    canRegister: false,
    inputDate2: '',
    //date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(new Date().setDate(new Date().getDate() - 1))).toISOString().substr(0, 10),
    menu2: false,
    startTimeDialog: false,
    endTimeDialog: false,
    startTimeDialogInput: null,
    endTimeDialogInput: null,
    description: null,
    dialogResult: null,
    showResultDialog: false,
    showLoaderDialog: false,
    showConfirmDialog: false,
    hasRegistered: true,
    isLoaded: false,
    hasReport: false,
    test: null,
    sleepHistory: []
  }),
  mounted() {
    _this = this
    this.getHistory()
  },
  methods: {
    inputDatePicker2() {
      if (this.hasReport) {
        let history = this.sleepHistory
        let registeredBefore = history.find(x => new Date(x.ModifiedDate.slice(0, 10)).getTime() === (new Date(this.date2).getTime()))
        if (registeredBefore === undefined) {
          this.canRegister = true
        } else {
          this.dialogResult = 'قبلا برای این روز ساعت خواب ثبت کرده اید.'
          this.showResultDialog = true
          this.canRegister = false
        }
      } else {
        this.canRegister = true
      }
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    registerTime() {
      this.showConfirmDialog = false;
      this.showLoaderDialog = true;

      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartTime", this.startTimeDialogInput);
      urlencoded.append("EndTime", this.endTimeDialogInput);
      urlencoded.append("Description", this.description);
      urlencoded.append("ModifiedDate", this.$convertDateToMiladi(this.inputDate2));
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);
      // for (const [key, value] of urlencoded.entries()) {
      //   console.log(key, value)
      // }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Dashboard/SetQualitySleep", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.dialogResult = result;
            _this.showResultDialog = true
            this.description= null
            this.date2=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            this.inputDate2= null
            this.startTimeDialogInput=null
            this.endTimeDialogInput= null
            this.getHistory()
          })
          .catch(error => console.log('error', error));
    },
    getHistory() {
      this.canRegister = false
      this.showLoaderDialog = true
      let currentDate = new Date()
      let last = new Date()
      let lastYear = last.setDate(last.getDate() - 365)
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.$convertDate(new Date(lastYear).toISOString()));
      urlencoded.append("EndDate", this.$convertDate(currentDate.toISOString()));
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_SleepQuality", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              this.hasReport = true
              this.sleepHistory = json
            } else {
              this.hasReport = false
              this.canRegister = true
            }
            _this.showLoaderDialog = false
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>